import { Link } from 'react-router-dom';
import { ROUTES } from 'shared/constants/routes';
import { Button } from 'shared/components/ui/Button';

export function NotFoundPage() {
  return (
    <section className="mx-auto max-w-md px-4 py-24 text-center">
      <h1 className="font-heading text-2xl font-bold text-ink">Página não encontrada</h1>
      <Link to={ROUTES.HOME} className="mt-6 inline-block">
        <Button>Voltar para o início</Button>
      </Link>
    </section>
  );
}
